(function(){
'use strict';
var $ = function(s, r){ return (r || document).querySelector(s); };
var $$ = function(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

/* ---------- blokada kopiowania (wzór driftzy) ---------- */
['copy','cut','contextmenu','selectstart'].forEach(function(ev){
  document.addEventListener(ev, function(e){ if(!(e.target.closest && e.target.closest('input,textarea'))) e.preventDefault(); });
});
document.addEventListener('dragstart', function(e){ if(e.target && /^(IMG|VIDEO|PICTURE|CANVAS|A)$/.test(e.target.tagName)) e.preventDefault(); }, true);

/* ---------- warianty ---------- */
// warianty podaje motyw (window.LM z Shopify); bez sklepu = ceny z karty produktu do podglądu
var LM = window.LM || {};
var WARIANTY = (LM.warianty && LM.warianty.length) ? LM.warianty : [
  { nazwa:'1 × 1 m', cena:17999, stara:27699, id:'' },
  { nazwa:'2 × 2 m', cena:19999, stara:30999, id:'' },
  { nazwa:'3 × 3 m', cena:22999, stara:35499, id:'' }
];
var SKLEP = !!window.Shopify;
var OBRAZEK = LM.obrazek || 'g1-dom-m.webp';
var zl = function(gr){ return (gr/100).toFixed(2).replace('.', ',') + ' zł'; };
var wybrany = 0;

var galeria = $('#galeria'), figury = $$('#galeria figure'), miniatury = $$('#miniatury button');
function pokazZdjecie(i, plynnie){ galeria.scrollTo({ left: i * galeria.clientWidth, behavior: plynnie ? 'smooth' : 'auto' }); }
function ustawWariant(i, zGalerii){
  wybrany = i;
  var w = WARIANTY[i], brak = SKLEP && (!w.id || w.dostepny === false), dod = $('#dodaj');
  dod.disabled = brak; dod.firstElementChild.textContent = brak ? 'Wkrótce dostępne' : 'Dodaj do koszyka';
  $$('#rozmiary button').forEach(function(b){ b.classList.toggle('on', +b.dataset.i === i); });
  $('#rozmiarNazwa').textContent = w.nazwa;
  $('#cena').textContent = zl(w.cena);
  var st = $('#cenaStara'), osz = $('#oszczedzasz'), rabat = w.stara > w.cena;
  [$('#cenaStaraWrap'), $('#cenaDol'), $('#rabatWrap')].forEach(function(e){ if(e) e.hidden = !rabat; });
  st.textContent = zl(w.stara);
  osz.textContent = 'Oszczędzasz ' + Math.round((w.stara - w.cena)/100) + ' zł';
  if($('#rabatProc')) $('#rabatProc').textContent = '-' + Math.floor((w.stara - w.cena) / w.stara * 100) + '%';
  var c = $('#cena'); c.classList.remove('miga'); void c.offsetWidth; c.classList.add('miga');
  $('#omnibus').textContent = 'Najniższa cena z 30 dni przed obniżką: ' + zl(w.cena);
  $('#ctaCena').textContent = zl(w.cena);
  $('#lepkiNazwa').textContent = 'Lightmas ' + w.nazwa;
  $('#lepkiCena').textContent = zl(w.cena);
  if(!zGalerii){
    var f = figury.findIndex(function(el){ return el.dataset.w === String(i); });
    if(f > -1) pokazZdjecie(f, true);
  }
}
if(galeria){
  $$('#rozmiary button').forEach(function(b){ b.addEventListener('click', function(){ ustawWariant(+b.dataset.i); }); });
  $$('.wybor-karta').forEach(function(b){ b.addEventListener('click', function(){
    ustawWariant(+b.dataset.i);
    $('#kup').scrollIntoView({ behavior:'smooth' });
  }); });
  miniatury.forEach(function(b, i){ b.addEventListener('click', function(){ pokazZdjecie(i, true); }); });
  var tGal;
  galeria.addEventListener('scroll', function(){
    clearTimeout(tGal);
    tGal = setTimeout(function(){
      var i = Math.round(galeria.scrollLeft / galeria.clientWidth);
      miniatury.forEach(function(b, k){ b.classList.toggle('on', k === i); });
      var w = figury[i] && figury[i].dataset.w;
      if(w !== undefined && w !== "" && +w !== wybrany) ustawWariant(+w, true);
    }, 80);
  }, { passive:true });
  // podgrzej zdjęcia galerii, żeby przełączanie było natychmiastowe
  addEventListener('load', function(){ $$('#galeria img').forEach(function(im){ if(im.decode) im.decode().catch(function(){}); }); });
  ustawWariant(0, true);
  $('#dodaj').addEventListener('click', dodaj);
}

/* ---------- koszyk (wysuwany): Shopify AJAX albo lokalny podgląd ---------- */
var koszyk = [];
function wiersz(obraz, tytul, wariant, ilosc, cena, zmien){
  var el = document.createElement('div'); el.className = 'poz';
  el.innerHTML = '<img src="' + obraz + '" alt="" width="64" height="64"><div><b>' + tytul + '</b>' + (wariant ? '<small>' + wariant + '</small>' : '') +
    '<div class="ilosc"><button data-a="-1" aria-label="Mniej">−</button><span>' + ilosc + '</span><button data-a="1" aria-label="Więcej">+</button></div></div>' +
    '<span class="poz-cena">' + zl(cena) + '</span>';
  $$('button', el).forEach(function(b){ b.addEventListener('click', function(){ zmien(+b.dataset.a); }); });
  return el;
}
function rysuj(pozycje, suma, sztuk){
  var lista = $('#koszykLista'); lista.innerHTML = '';
  if(!pozycje.length) lista.innerHTML = '<p class="pusty">Koszyk jest pusty</p>';
  pozycje.forEach(function(el){ lista.appendChild(el); });
  $('#koszykSuma').textContent = zl(suma);
  var l = $('#licznik'); l.textContent = sztuk; l.classList.toggle('on', sztuk > 0);
}
function rysujKoszyk(dane){
  if(SKLEP){
    if(!dane) return fetch('/cart.js').then(function(r){ return r.json(); }).then(rysujKoszyk);
    return rysuj(dane.items.map(function(it){
      return wiersz(it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : OBRAZEK, it.product_title,
        it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '', it.quantity, it.final_line_price, function(d){
          fetch('/cart/change.js', { method:'POST', headers:{ 'Content-Type':'application/json' }, body: JSON.stringify({ id: it.key, quantity: it.quantity + d }) })
            .then(function(r){ return r.json(); }).then(rysujKoszyk);
        });
    }), dane.total_price, dane.item_count);
  }
  var suma = 0, sztuk = 0;
  rysuj(koszyk.map(function(p, k){
    var w = WARIANTY[p.w]; suma += w.cena * p.ilosc; sztuk += p.ilosc;
    return wiersz(OBRAZEK, 'Lightmas', w.nazwa, p.ilosc, w.cena * p.ilosc, function(d){
      p.ilosc += d; if(p.ilosc < 1) koszyk.splice(k, 1); rysujKoszyk();
    });
  }), suma, sztuk);
}
function otworzKoszyk(){ document.body.classList.add('koszyk-otwarty'); }
function zamknijKoszyk(){ document.body.classList.remove('koszyk-otwarty'); }
function dodaj(){
  var b = $('#dodaj'); if(b.disabled) return;
  if(SKLEP){
    b.classList.add('laduje');
    return fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json' }, body: JSON.stringify({ items:[{ id: WARIANTY[wybrany].id, quantity:1 }] }) })
      .then(function(){ return rysujKoszyk(); }).then(function(){ b.classList.remove('laduje'); otworzKoszyk(); });
  }
  var p = koszyk.find(function(x){ return x.w === wybrany; });
  if(p) p.ilosc++; else koszyk.push({ w: wybrany, ilosc: 1 });
  rysujKoszyk(); otworzKoszyk();
}
$('#otworzKoszyk').addEventListener('click', otworzKoszyk);
$('#zamknijKoszyk').addEventListener('click', zamknijKoszyk);
$('#koszykTlo').addEventListener('click', zamknijKoszyk);
$('#doKasy').addEventListener('click', function(){
  var z = $('#zgoda');
  if(!z.checked){ z.closest('.zgoda').classList.add('blad'); return; }
  if(SKLEP && +$('#licznik').textContent > 0) location.href = '/checkout';
});
$('#zgoda').addEventListener('change', function(){ this.closest('.zgoda').classList.remove('blad'); });
rysujKoszyk();
if(location.hash === '#koszyk') otworzKoszyk();

/* ---------- sticky „Kup teraz” ---------- */
var lepki = $('#lepki'), cta = $('#dodaj'), finalSek = $('#final');
if(lepki && cta){
  var widac = { cta:true, final:false };
  var io = new IntersectionObserver(function(wpisy){
    wpisy.forEach(function(w){ if(w.target === cta) widac.cta = w.isIntersecting || w.boundingClientRect.top > 0; if(w.target === finalSek) widac.final = w.isIntersecting; });
    lepki.classList.toggle('on', !widac.cta && !widac.final);
  });
  io.observe(cta); if(finalSek) io.observe(finalSek);
}

/* ---------- pojawianie się sekcji ---------- */
var ioPokaz = new IntersectionObserver(function(wpisy){
  wpisy.forEach(function(w){
    if(!w.isIntersecting) return;
    var el = w.target, i = Array.prototype.indexOf.call(el.parentElement.children, el);
    el.style.transitionDelay = Math.min(i, 4) * 0.08 + 's';
    el.classList.add('on'); ioPokaz.unobserve(el);
    $$('[data-do]', el).forEach(liczDo);
  });
}, { rootMargin:'0px 0px -12% 0px' });
$$('.pokaz-sie').forEach(function(el){ ioPokaz.observe(el); });
function liczDo(b){
  var cel = +b.dataset.do, plus = b.hasAttribute('data-plus'), t0 = performance.now();
  (function krok(t){
    var p = Math.min(1, (t - t0) / 1400), e = 1 - Math.pow(1 - p, 3);
    b.textContent = Math.round(cel * e) + (plus && p === 1 ? '+' : '');
    if(p < 1) requestAnimationFrame(krok);
  })(t0);
}
$$('.final').forEach(function(sek){
  new IntersectionObserver(function(w, o){ if(w[0].isIntersecting){ sek.classList.add('on'); o.disconnect(); } }, { threshold:.25 }).observe(sek);
});

/* ---------- śnieg w tle ---------- */
(function(){
  var c = $('#snieg'), ctx = c.getContext('2d'), dpr = Math.min(devicePixelRatio || 1, 2), W, H, platki = [];
  function rozmiar(){ W = innerWidth; H = innerHeight; c.width = W*dpr; c.height = H*dpr; ctx.setTransform(dpr,0,0,dpr,0,0); }
  rozmiar(); var szer0 = innerWidth; addEventListener('resize', function(){ if(innerWidth !== szer0 || innerHeight > H){ szer0 = innerWidth; rozmiar(); } });
  var ile = innerWidth < 700 ? 34 : 70;
  for(var i=0;i<ile;i++) platki.push({ x:Math.random()*W, y:Math.random()*H, r:Math.random()*2+0.6, v:Math.random()*0.5+0.25, f:Math.random()*6.28 });
  function klatka(){
    if(!document.hidden){
      ctx.clearRect(0,0,W,H); ctx.fillStyle = 'rgba(255,255,255,.7)'; ctx.beginPath();
      platki.forEach(function(p){
        p.y += p.v; p.f += 0.01; p.x += Math.sin(p.f) * 0.3;
        if(p.y > H + 4){ p.y = -4; p.x = Math.random()*W; }
        ctx.moveTo(p.x + p.r, p.y); ctx.arc(p.x, p.y, p.r, 0, 6.283);
      });
      ctx.fill();
    }
    requestAnimationFrame(klatka);
  }
  requestAnimationFrame(klatka);
})();

/* =========================================================
   KURTYNA LED – symulacja na canvasie (32 × 32 diody)
   ========================================================= */
var N = 32;
var PALETA = [[255,60,80],[255,200,60],[60,220,120],[70,160,255],[255,120,220],[255,255,255]];
function hash(x, y){ var h = Math.sin(x*127.1 + y*311.7) * 43758.5453; return h - Math.floor(h); }
function hsl(h, s, l){
  h = ((h % 360) + 360) % 360 / 360;
  var q = l < .5 ? l*(1+s) : l+s-l*s, p = 2*l-q;
  function f(t){ t<0&&(t+=1); t>1&&(t-=1); return t<1/6?p+(q-p)*6*t:t<1/2?q:t<2/3?p+(q-p)*(2/3-t)*6:p; }
  return [f(h+1/3)*255|0, f(h)*255|0, f(h-1/3)*255|0];
}
function mnoz(k, a){ return [k[0]*a|0, k[1]*a|0, k[2]*a|0]; }

// czcionka 5×7, wiersze w hex; polskie litery = litera bazowa + akcent
var FONT = {
A:'0e11111f111111',B:'1e11111e11111e',C:'0e11101010110e',D:'1e11111111111e',E:'1f10101e10101f',F:'1f10101e101010',G:'0e111017111 10f',
H:'1111111f111111',I:'0e04040404040e',J:'0702020202120c',K:'11121418141211',L:'1010101010101f',M:'111b1515111111',N:'11111915131111',
O:'0e11111111110e',P:'1e11111e101010',Q:'0e11111115120d',R:'1e11111e141211',S:'0f10100e01011e',T:'1f040404040404',U:'1111111111110e',
V:'1111111111 0a04',W:'1111111515150a',X:'11110a040a1111',Y:'11110a04040404',Z:'1f01020408101f',
'0':'0e111315191 10e','1':'040c040404040e','2':'0e11010204081f','3':'1f02040201110e','4':'02060a121f0202','5':'1f101e0101110e',
'6':'0608101e11110e','7':'1f010204080808','8':'0e11110e11110e','9':'0e11110f01020c','!':'04040404040004','?':'0e110102040004',
'.':'0000000000 0c0c',',':'00000000 0c0408','-':'0000001f000000','♥':'0a1f1f1f0e0400','Ł':'1010141810101f',':':'000c0c000c0c00'
};
var AKCENT = { 'Ą':['A',0,2],'Ć':['C',2,0],'Ę':['E',0,2],'Ń':['N',2,0],'Ó':['O',2,0],'Ś':['S',2,0],'Ź':['Z',2,0],'Ż':['Z',4,0] };
function glif(ch){
  var g = { rows:[0,0,0,0,0,0,0,0,0], w:5 };
  if(ch === ' '){ g.w = 3; return g; }
  var a = AKCENT[ch], baza = a ? a[0] : ch, hex = (FONT[baza] || FONT['?']).replace(/ /g,'');
  for(var r=0;r<7;r++) g.rows[r+1] = parseInt(hex.substr(r*2,2),16);
  if(a){ g.rows[0] = a[1]; g.rows[8] = a[2]; }
  return g;
}
// napis -> mapa kolumn (każda kolumna = tablica 9 bitów + kolor litery)
function mapaNapisu(txt){
  var kol = [], lit = 0;
  txt.toUpperCase().split('').forEach(function(ch){
    var g = glif(ch), kolor = PALETA[lit++ % 5];
    for(var c=0;c<g.w;c++){
      var bity = []; for(var r=0;r<9;r++) bity.push((g.rows[r] >> (4-c)) & 1);
      kol.push({ b:bity, k:kolor });
    }
    kol.push({ b:[0,0,0,0,0,0,0,0,0], k:null });
  });
  return kol;
}

// ---- sceny: (x, y, t) -> [r,g,b] albo null ----
function tlo(x, y, t){ // delikatny padający śnieg
  var s = hash(x, 0);
  if(s > .82){ var yy = (t*4*(0.6+s) + s*80) % (N+6) - 3; if(Math.abs(y - yy) < .6) return [150,170,210]; }
  return null;
}
var SCENY = {
  wylaczone: function(){ return null; },
  choinka: function(x, y, t){
    var cx = 15.5, dx = Math.abs(x - cx);
    if(y >= 1 && y <= 5){ // gwiazda
      var g = (dx < 0.6 && y >= 1 && y <= 5) || (y === 3 && dx < 2.6) || (y === 2 || y === 4) && dx < 1.6;
      if(g) return mnoz([255,210,70], .75 + .25*Math.sin(t*6));
    }
    var tiery = [[5,13,0],[10,20,1],[15,26,2]];
    for(var i=0;i<3;i++){
      var a = tiery[i][0], b = tiery[i][1];
      if(y >= a && y <= b && dx <= 1 + (y-a)*0.62 + i*0.8){
        var h = hash(x, y);
        if(h > .84) return mnoz(PALETA[(h*100|0) % 5], (Math.sin(t*4 + h*20) > -.2) ? 1 : .25);
        if(((y - a) + Math.round(x*0.5)) % 5 === 0 && h > .35) return [255,200,90];
        return [20 + (h*30|0), 150 + (h*60|0), 60];
      }
    }
    if(y >= 27 && y <= 28 && dx < 2) return [140,80,30];
    if(y >= 29) return mnoz([200,220,255], .35 + hash(x,y)*.2);
    return tlo(x, y, t);
  },
  balwan: function(x, y, t){
    var d1 = Math.hypot(x-15.5, y-22.5), d2 = Math.hypot(x-15.5, y-12.5);
    if(y >= 4 && y <= 7 && Math.abs(x-15.5) < 3.2) return [230,40,60];
    if(y === 8 && Math.abs(x-15.5) < 5) return [230,40,60];
    if((y === 11 && (x === 14 || x === 17))) return null;
    if(y === 13 && x >= 16 && x <= 19) return [255,140,30];
    if(y === 16 && x >= 12 && x <= 19) return [60,200,120];
    if(d1 < 7.2 && x === 15 && (y === 19 || y === 22 || y === 25)) return [230,40,60];
    if(d1 < 7.2 || d2 < 4.8) return [235,242,255];
    if(y >= 30) return [180,200,255];
    var h = hash(x,y); if(h > .975) return mnoz([255,220,120], .5 + .5*Math.sin(t*5 + h*40));
    return tlo(x, y, t);
  },
  serce: function(x, y, t){
    var s = 1 + .08*Math.sin(t*5), u = (x - 15.5) / (9.5*s), v = -(y - 15) / (9.5*s);
    var f = Math.pow(u*u + v*v - 1, 3) - u*u*v*v*v;
    if(f <= 0) return hsl(345 + v*20, 1, .55 + .15*Math.sin(t*3 + u*3));
    var h = hash(x,y); if(h > .96) return mnoz([255,150,200], .5 + .5*Math.sin(t*4 + h*30));
    return null;
  },
  snieg: function(x, y, t){
    var s = hash(x, 7);
    var yy = (t*5*(0.5+s) + s*120) % (N+8) - 4;
    if(Math.abs(y - yy) < .6) return mnoz([220,235,255], .6 + s*.4);
    var s2 = hash(x, 9); var yy2 = (t*3*(0.5+s2) + s2*90) % (N+8) - 4;
    if(s2 > .5 && Math.abs(y - yy2) < .6) return [120,170,255];
    if(y >= 29 + Math.round(Math.sin(x*.6)*1)) return [200,220,255];
    var h = hash(x,y); if(h > .98) return mnoz([255,215,90], .5 + .5*Math.sin(t*6 + h*50));
    return null;
  },
  muzyka: function(x, y, t){
    var poz = Math.abs(Math.sin(x*.55 + t*3.1) * .55 + Math.sin(x*1.7 - t*5.3) * .3 + Math.sin(t*7.7 + x*.2) * .15);
    var wys = Math.round(4 + poz * 24);
    if(x % 2 === 1 && N - 1 - y < wys) return hsl(120 - (N-1-y)*4.2 + t*30, 1, .55);
    return null;
  },
  tecza: function(x, y, t){ return hsl((x + y)*9 - t*140, 1, .55); }
};
function scenaNapis(txt){
  var mapa = mapaNapisu(txt), szer = mapa.length*2 + N;           // litery w skali 2 × 2
  return function(x, y, t){
    var c = (Math.floor(t*16) % szer - N + x) >> 1;
    var r = y - 7;
    if(c >= 0 && c < mapa.length && r >= 0 && r < 18){
      var k = mapa[c]; if(k.b[r >> 1]) return k.k;
    }
    if(y === 3 || y === 28){ var h = (x + Math.floor(t*8)) % 4; return h === 0 ? PALETA[(x>>2)%5] : null; }
    return tlo(x, y, t);
  };
}
SCENY.napis = scenaNapis('Wesołych Świąt ♥');

// ---- rysowanie ----
function Kurtyna(canvas){
  this.c = canvas; this.ctx = canvas.getContext('2d'); this.sprity = {}; this.rozmiar();
  var self = this; addEventListener('resize', function(){ self.rozmiar(); });
}
Kurtyna.prototype.rozmiar = function(){
  var dpr = Math.min(devicePixelRatio || 1, 2), w = this.c.clientWidth || 300;
  this.c.width = this.c.height = Math.round(w * dpr);
  this.kom = this.c.width / N; this.sprity = {};
};
Kurtyna.prototype.sprite = function(k){
  var q = [k[0]>>4, k[1]>>4, k[2]>>4], klucz = q.join(',');
  var s = this.sprity[klucz]; if(s) return s;
  var r = Math.ceil(this.kom * 1.25), c = document.createElement('canvas'); c.width = c.height = r*2;
  var x = c.getContext('2d'), kol = 'rgb(' + (q[0]<<4) + ',' + (q[1]<<4) + ',' + (q[2]<<4) + ')';
  var g = x.createRadialGradient(r, r, 0, r, r, r);
  g.addColorStop(0, 'rgba(' + (q[0]<<4) + ',' + (q[1]<<4) + ',' + (q[2]<<4) + ',.55)'); g.addColorStop(1, 'rgba(0,0,0,0)');
  x.fillStyle = g; x.fillRect(0, 0, r*2, r*2);
  x.fillStyle = kol; x.beginPath(); x.arc(r, r, this.kom*0.3, 0, 6.283); x.fill();
  x.fillStyle = 'rgba(255,255,255,.55)'; x.beginPath(); x.arc(r, r, this.kom*0.13, 0, 6.283); x.fill();
  return (this.sprity[klucz] = c);
};
// scenaA -> scenaB z falą po przekątnej (p = 0..1)
Kurtyna.prototype.rysuj = function(scA, scB, p, t){
  var ctx = this.ctx, k = this.kom, W = this.c.width;
  ctx.globalCompositeOperation = 'source-over';
  ctx.fillStyle = '#03060f'; ctx.fillRect(0, 0, W, W);
  ctx.fillStyle = 'rgba(120,140,190,.10)';
  for(var x=0;x<N;x++) ctx.fillRect((x + .5)*k - .5, 0, 1, W);    // przewody
  ctx.fillStyle = 'rgba(150,165,210,.16)'; ctx.beginPath();
  for(var y=0;y<N;y++) for(x=0;x<N;x++){ ctx.moveTo((x+.5)*k + k*.16, (y+.5)*k); ctx.arc((x+.5)*k, (y+.5)*k, k*.16, 0, 6.283); }
  ctx.fill();                                                        // zgaszone diody
  ctx.globalCompositeOperation = 'lighter';
  for(y=0;y<N;y++) for(x=0;x<N;x++){
    var prog = (x + y) / (2*N - 2), scena = p >= 1 || prog < p*1.15 - .1 ? scB : scA;
    var kol = scena(x, y, t);
    if(kol){ var s = this.sprite(kol); ctx.drawImage(s, (x+.5)*k - s.width/2, (y+.5)*k - s.height/2); }
  }
};

// ---- demo: własny napis ----
(function(){
  var okno = $('#ledDemo'); if(!okno) return;
  var kurt = new Kurtyna(okno), pole = $('#demoNapis');
  var obecna = okno.dataset.napis ? scenaNapis(okno.dataset.napis) : SCENY.napis, poprzednia = SCENY.wylaczone, start = 0, widoczna = false, t0 = 0;
  new IntersectionObserver(function(w){ widoczna = w[0].isIntersecting; }).observe(okno);
  function zmien(sc){ poprzednia = obecna; obecna = sc; start = performance.now(); t0 = performance.now(); }
  function napis(){ var v = pole.value.trim() || 'Lightmas'; zmien(scenaNapis(v)); $$('#demoWzory button').forEach(function(b){ b.classList.remove('on'); }); }
  $('#demoPokaz').addEventListener('click', napis);
  pole.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); napis(); pole.blur(); } });
  $$('#demoWzory button').forEach(function(b){ b.addEventListener('click', function(){
    $$('#demoWzory button').forEach(function(x){ x.classList.toggle('on', x === b); });
    zmien(SCENY[b.dataset.s]);
  }); });
  var ostatnia = 0;
  function klatka(t){
    requestAnimationFrame(klatka);
    if(!widoczna || t - ostatnia < 30) return; ostatnia = t;
    var p = Math.min(1, (t - start) / 700);
    kurt.rysuj(poprzednia, obecna, p, (t - t0)/1000);
  }
  requestAnimationFrame(klatka);
})();

// ---- suwak przed / po ----
(function(){
  var su = $('#suwak'); if(!su) return;
  var ciagnie = false;
  function ustaw(x){ var r = su.getBoundingClientRect(); su.style.setProperty('--p', Math.max(2, Math.min(98, (x - r.left) / r.width * 100)) + '%'); }
  su.addEventListener('pointerdown', function(e){ ciagnie = true; su.classList.add('ruch'); ustaw(e.clientX); });
  addEventListener('pointermove', function(e){ if(ciagnie) ustaw(e.clientX); }, { passive:true });
  addEventListener('pointerup', function(){ ciagnie = false; });
  addEventListener('pointercancel', function(){ ciagnie = false; });
  // podpowiedź: raz sam się przesuwa, gdy ktoś do niego dojedzie
  new IntersectionObserver(function(w, o){
    if(!w[0].isIntersecting || su.classList.contains('ruch')) return; o.disconnect();
    var t0 = performance.now();
    (function anim(t){
      if(su.classList.contains('ruch')) return;
      var p = Math.min(1, (t - t0) / 2600), v = 50 + Math.sin(p * Math.PI * 2) * 38 * (1 - p);
      su.style.setProperty('--p', v + '%'); if(p < 1) requestAnimationFrame(anim);
    })(t0);
  }, { threshold:.6 }).observe(su);
})();

})();
